<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle :value="isCollapsible" @input="onInput" />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'icon-search-collapse';

export default {
    name: 'icon-search-collapse',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Auto Collapse',
            durationIndex: 0,
            isCollapsible: true,
            message: '* Turn off to disable the automatic collapsing of the search form when it‘s not in use.',
        };
    },

    created() {
        this.durationIndex = this.defaultDurationIndex;
    },

    methods: {
        onInput(isChecked) {
            this.isCollapsible = isChecked;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, isChecked);
            this.onOptionChange(isChecked);
        },

        onSelectedElement() {
            this.isCollapsible = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);
        },
    },
};
</script>
